import { Box, styled } from "@mui/material";
import { IStyledBoxCardProps } from "./types";

const StyledBoxCard = styled(Box)<IStyledBoxCardProps>(({ theme }) => ({
    backgroundColor: (theme as any).palette.neutral.darkest,
    border: "1px solid rgba(255, 255, 255, 0.06)",
    padding: theme.spacing(3),
    boxSizing: 'border-box',
    borderRadius: (theme as any).shape.border.general.radius[4],
}))

export { StyledBoxCard }